function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('h1',[_vm._v("Traffic insights")]),_vm._v(" "),_c('p',[_vm._v("Web analytics platforms give you statistics hard to grasp. WhiteBox helps you focus on prospects interested in your business. Measure the key indicators in your customer journey: from ads, through call, to visitation and sale, so you could optimize your online and offline efforts to boost your business performance.")])])}]

return { render, staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"href":"/home/traffic-insights","image":"/img/traffic-insights.svg","summary":"WhiteBox helps you focus on prospects"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }